// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IErrorDto,
  IFileErrorDto,
  IFileImportResponse,
  IFileInfoDto,
  IFileRecordDto,
  IFileUrlDto,
  IGenericErrorDto,
  IPageFileInfoDto,
  IPageable,
  IPatchFileDto,
  ISearchFileDto,
} from '../models/index';
import {
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IFileErrorDtoFromJSON,
    IFileErrorDtoToJSON,
    IFileImportResponseFromJSON,
    IFileImportResponseToJSON,
    IFileInfoDtoFromJSON,
    IFileInfoDtoToJSON,
    IFileRecordDtoFromJSON,
    IFileRecordDtoToJSON,
    IFileUrlDtoFromJSON,
    IFileUrlDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IPageFileInfoDtoFromJSON,
    IPageFileInfoDtoToJSON,
    IPageableFromJSON,
    IPageableToJSON,
    IPatchFileDtoFromJSON,
    IPatchFileDtoToJSON,
    ISearchFileDtoFromJSON,
    ISearchFileDtoToJSON,
} from '../models/index';

export interface ApproveFileRequest {
    fileId: number;
}

export interface CancelFileRequest {
    fileId: number;
}

export interface ContinueFileProcessingRequest {
    fileId: number;
}

export interface GetFileByIdRequest {
    fileId: number;
}

export interface GetFileErrorsRequest {
    fileId: number;
    pageable: IPageable;
}

export interface GetFileRecords1Request {
    fileId: number;
    pageable: IPageable;
}

export interface GetFileUrlByIdRequest {
    fileId: number;
}

export interface GetFiles1Request {
    pageable: IPageable;
    iSearchFileDto: ISearchFileDto;
}

export interface HandleDeleteFileByIdRequest {
    fileId: number;
}

export interface HandleFileUploadRequest {
    file: Blob;
    dryRun?: boolean;
    uploadWay?: HandleFileUploadUploadWayEnum;
}

export interface PatchFileRequest {
    fileId: number;
    iPatchFileDto: IPatchFileDto;
}

export interface ReprocessNotProcessedRecordsRequest {
    fileId: number;
}

/**
 * FileProcessorServiceServiceApi - interface
 * 
 * @export
 * @interface FileProcessorServiceServiceApiInterface
 */
export interface FileProcessorServiceServiceApiInterface {
    /**
     * 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    approveFileRaw(requestParameters: ApproveFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>>;

    /**
     */
    approveFile(requestParameters: ApproveFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto>;

    /**
     * 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    cancelFileRaw(requestParameters: CancelFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>>;

    /**
     */
    cancelFile(requestParameters: CancelFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto>;

    /**
     * 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    continueFileProcessingRaw(requestParameters: ContinueFileProcessingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileImportResponse>>;

    /**
     */
    continueFileProcessing(requestParameters: ContinueFileProcessingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileImportResponse>;

    /**
     * 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    getFileByIdRaw(requestParameters: GetFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>>;

    /**
     */
    getFileById(requestParameters: GetFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto>;

    /**
     * 
     * @param {number} fileId 
     * @param {IPageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    getFileErrorsRaw(requestParameters: GetFileErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileErrorDto>>;

    /**
     */
    getFileErrors(requestParameters: GetFileErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileErrorDto>;

    /**
     * 
     * @param {number} fileId 
     * @param {IPageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    getFileRecords1Raw(requestParameters: GetFileRecords1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileRecordDto>>;

    /**
     */
    getFileRecords1(requestParameters: GetFileRecords1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileRecordDto>;

    /**
     * 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    getFileUrlByIdRaw(requestParameters: GetFileUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlDto>>;

    /**
     */
    getFileUrlById(requestParameters: GetFileUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlDto>;

    /**
     * 
     * @param {IPageable} pageable 
     * @param {ISearchFileDto} iSearchFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    getFiles1Raw(requestParameters: GetFiles1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageFileInfoDto>>;

    /**
     */
    getFiles1(requestParameters: GetFiles1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageFileInfoDto>;

    /**
     * delete file by id
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    handleDeleteFileByIdRaw(requestParameters: HandleDeleteFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * delete file by id
     */
    handleDeleteFileById(requestParameters: HandleDeleteFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Upload file.
     * @param {Blob} file file to be uploaded
     * @param {boolean} [dryRun] identifies if to process file without or with storing details to db
     * @param {'FTP' | 'UI'} [uploadWay] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    handleFileUploadRaw(requestParameters: HandleFileUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileImportResponse>>;

    /**
     * Upload file.
     */
    handleFileUpload(requestParameters: HandleFileUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileImportResponse>;

    /**
     * 
     * @param {number} fileId 
     * @param {IPatchFileDto} iPatchFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    patchFileRaw(requestParameters: PatchFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>>;

    /**
     */
    patchFile(requestParameters: PatchFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto>;

    /**
     * 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    reprocessNotProcessedRecordsRaw(requestParameters: ReprocessNotProcessedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    reprocessNotProcessedRecords(requestParameters: ReprocessNotProcessedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Stream file status events via SSE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileProcessorServiceServiceApiInterface
     */
    streamSseMvcRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stream file status events via SSE
     */
    streamSseMvc(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class FileProcessorServiceServiceApi extends runtime.BaseAPI implements FileProcessorServiceServiceApiInterface {

    /**
     */
    async approveFileRaw(requestParameters: ApproveFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling approveFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/approve/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async approveFile(requestParameters: ApproveFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto> {
        const response = await this.approveFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cancelFileRaw(requestParameters: CancelFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling cancelFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/cancel/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async cancelFile(requestParameters: CancelFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto> {
        const response = await this.cancelFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async continueFileProcessingRaw(requestParameters: ContinueFileProcessingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileImportResponse>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling continueFileProcessing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/process-duplicate/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileImportResponseFromJSON(jsonValue));
    }

    /**
     */
    async continueFileProcessing(requestParameters: ContinueFileProcessingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileImportResponse> {
        const response = await this.continueFileProcessingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFileByIdRaw(requestParameters: GetFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getFileById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFileById(requestParameters: GetFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto> {
        const response = await this.getFileByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFileErrorsRaw(requestParameters: GetFileErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileErrorDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getFileErrors().'
            );
        }

        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling getFileErrors().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files/{file-id}/errors`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileErrorDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFileErrors(requestParameters: GetFileErrorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileErrorDto> {
        const response = await this.getFileErrorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFileRecords1Raw(requestParameters: GetFileRecords1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileRecordDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getFileRecords1().'
            );
        }

        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling getFileRecords1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files/{file-id}/records`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileRecordDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFileRecords1(requestParameters: GetFileRecords1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileRecordDto> {
        const response = await this.getFileRecords1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFileUrlByIdRaw(requestParameters: GetFileUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileUrlDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getFileUrlById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/file-link/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileUrlDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFileUrlById(requestParameters: GetFileUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileUrlDto> {
        const response = await this.getFileUrlByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFiles1Raw(requestParameters: GetFiles1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageFileInfoDto>> {
        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling getFiles1().'
            );
        }

        if (requestParameters['iSearchFileDto'] == null) {
            throw new runtime.RequiredError(
                'iSearchFileDto',
                'Required parameter "iSearchFileDto" was null or undefined when calling getFiles1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ISearchFileDtoToJSON(requestParameters['iSearchFileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageFileInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFiles1(requestParameters: GetFiles1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageFileInfoDto> {
        const response = await this.getFiles1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete file by id
     */
    async handleDeleteFileByIdRaw(requestParameters: HandleDeleteFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling handleDeleteFileById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete file by id
     */
    async handleDeleteFileById(requestParameters: HandleDeleteFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.handleDeleteFileByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Upload file.
     */
    async handleFileUploadRaw(requestParameters: HandleFileUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileImportResponse>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling handleFileUpload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dryRun'] != null) {
            queryParameters['dry_run'] = requestParameters['dryRun'];
        }

        if (requestParameters['uploadWay'] != null) {
            queryParameters['upload_way'] = requestParameters['uploadWay'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/files/csv/import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileImportResponseFromJSON(jsonValue));
    }

    /**
     * Upload file.
     */
    async handleFileUpload(requestParameters: HandleFileUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileImportResponse> {
        const response = await this.handleFileUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchFileRaw(requestParameters: PatchFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFileInfoDto>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling patchFile().'
            );
        }

        if (requestParameters['iPatchFileDto'] == null) {
            throw new runtime.RequiredError(
                'iPatchFileDto',
                'Required parameter "iPatchFileDto" was null or undefined when calling patchFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/files/{file-id}`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IPatchFileDtoToJSON(requestParameters['iPatchFileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFileInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async patchFile(requestParameters: PatchFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFileInfoDto> {
        const response = await this.patchFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reprocessNotProcessedRecordsRaw(requestParameters: ReprocessNotProcessedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling reprocessNotProcessedRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/file/{file-id}/reprocess-records`;
        urlPath = urlPath.replace(`{${"file-id"}}`, encodeURIComponent(String(requestParameters['fileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async reprocessNotProcessedRecords(requestParameters: ReprocessNotProcessedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reprocessNotProcessedRecordsRaw(requestParameters, initOverrides);
    }

    /**
     * Stream file status events via SSE
     */
    async streamSseMvcRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/file-status-event/stream`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stream file status events via SSE
     */
    async streamSseMvc(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.streamSseMvcRaw(initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum HandleFileUploadUploadWayEnum {
    FTP = 'FTP',
    UI = 'UI'
}
